var gheMeldungReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    if (action.type === 'SAVE_DATA_GHE') {
        var values = action.meldung;
        return {
            ghe_1_groesse_formatted: values.ghe_1_groesse_formatted,
            ghe_2_groesse_formatted: values.ghe_2_groesse_formatted,
            ghe_3_groesse_formatted: values.ghe_3_groesse_formatted
        };
    }
    else if (action.type === 'CLEAR_DATA_GHE') {
        return null;
    }
    return state;
};
export default gheMeldungReducer;
